import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import jstools from 'jstools-common/dist/jstools.web'
import ElementUI from 'element-ui';
import '@/assets/styles/base.less';
import '@/assets/styles/index.less';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.prototype.$jstools = jstools;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
